import React, { Component } from 'react'
import styled from 'styled-components'
import { withTranslation } from 'react-i18next'
import classNames from 'classnames'
import ArticleDialog from './ArticleDialog'
import { connect } from "react-redux";

const ArticleContainer = styled.div`
    margin: 0;
    padding: 0;
    clear: both;
    display: flex;

    // Mobile version.
    @media (max-width: 768px) {
        flex-wrap: wrap;
    }

    .hidden {
        display: none;
    }

    > div.video-area {
        flex: none;
        float: left;
        height: 298px;
        width: 530px;
        margin-right: 30px;
        margin-bottom: 25px;

        // Mobile version.
        @media (max-width: 768px) {
            width: auto;
            height: auto;
            margin: 0;
            float: none;
        }
    }

    > div.article-section{
      padding-bottom: 15px;

        > h3 {
            font-family: Lato-Light;
            font-size: 18px;
            color: #4D4D4D;
            line-height: 22px;
        }

        > p {
            font-family: Lato-Regular;
            font-size: 14px;
            color: #2B2B2B;
            line-height: 22px;
        }
        > a {
            font-family: Lato-Regular;
            font-size: 14px;
            color: #11959A;
            line-height: 16px;
            text-decoration: none;
        }
    }
`

export class Article extends Component {

    constructor(props) {
        super(props);

        this.state = {
            articleDialogVisible: false
        }

        const script1 = document.createElement("script");
        const script2 = document.createElement("script");

        if(this.props.video_url) {
            script1.src = `https://fast.wistia.com/embed/medias/${this.props.video_url}.jsonp`;
            script1.async = true;

            script2.src = "https://fast.wistia.com/assets/external/E-v1.js";
            script2.async = true;

            document.body.appendChild(script1);
            document.body.appendChild(script2);
        }
    }

    readMoreClickHandler = () => {
        this.setState({
            articleDialogVisible: true
        })
    }

    articleOnCloseDialog = () => {
        this.setState({
            articleDialogVisible: false
        })
    }



    render() {

        const { t } = this.props
        const isArticle = this.props.video_url.trim() === "" ? true : false

        let divClasses = classNames('video-area', {
            'hidden': isArticle
        })

        const videoUrl = "https://broadcast.amazon.com/embed/" + this.props.video_url

        return(
            <ArticleContainer className="article">
                <div className={divClasses}>
                    <iframe sandbox="allow-scripts allow-popups allow-presentation allow-same-origin" 
                        src={videoUrl} 
                        width="100%" 
                        height="100%" 
                        style={{border: '0', position:'relative'}} 
                        allowFullScreen
                    />
                </div>
                <div className="article-section">
                    <h3>{this.props.title}</h3>
                    <p>{this.props.description}</p>
                    {this.props.body && this.props.body.length > 0 &&
                    <a href="#" onClick={this.readMoreClickHandler}>{t('HelpfulInformation.Article.ReadMore')}</a>}
                </div>
                <ArticleDialog
                    visible={this.state.articleDialogVisible}
                    onCloseDialog={this.articleOnCloseDialog}
                    title={this.props.title}
                    body={this.props.body}
                />
            </ArticleContainer>
        )
    }
}


const mapState = state => ({
  content: state.static_content.helpful_information
})

export default connect(mapState)(withTranslation('translations')(Article))
